import React, { Component } from 'react';
import { every, isEmpty } from 'lodash';
import classNames from 'classnames';
import { Icon } from 'ui';
import request from 'utils/request_ajax';

/* eslint react/no-array-index-key:0 */

class PasswordForm extends Component {
  state = {
    password: null,
    password_confirmation: null,
    errors: {},
    done: false,
  };

  get notEmpty() {
    return every([
      !isEmpty(this.state.password),
      !isEmpty(this.state.password_confirmation),
    ]);
  }

  get passwordMatch() {
    return this.state.password === this.state.password_confirmation;
  }

  get disableSubmitButton() {
    return !(this.notEmpty && this.passwordMatch);
  }

  handleInputChange = ({ target }) => {
    this.setState({ [target.name]: target.value });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { user } = this.props;

    request
      .putJSON(`/users/${user.id}/reset_password`, {
        user: {
          password: this.state.password,
          password_confirmation: this.state.password_confirmation,
        },
      })
      .then(() => {
        this.setState({ ...PasswordForm.defaultState, done: true });
      })
      .fail(({ responseJSON: { errors } }) => {
        this.setState({ errors });
      });
  };

  render() {
    const { errors, done } = this.state;
    const passwordRequirement = this.props.useWeakPasswordValidation
      ? t('users.reset_password.old_password_requirements')
      : t('common.password_requirements_html');

    if (done) {
      return (
        <div>
          <p className="c-green">
            <Icon name="saved" /> {t('common.success')}!
          </p>
          <p>{t('users.notifications.reset_password.success')}</p>
        </div>
      );
    }

    const submitButtonClass = classNames(
      'NewButton NewButton--fw NewButton--center NewButton--tall CustomColor--backgroundColor CustomColor--buttonBoxShadow NewButton--lessonlyBrandColor',
      {
        'NewButton--disabled': this.disableSubmitButton,
      },
    );

    return (
      <form onSubmit={this.handleSubmit}>
        <label htmlFor="password" className="c-gray-darker">
          {t('common.new_password')}
        </label>
        <input
          id="password"
          type="password"
          name="password"
          onChange={this.handleInputChange}
          className="NewInput NewInput--white NewInput--fw mb-8"
          required
        />
        <p
          className="HelpText HelpText--muted HelpText--noBottomMargin"
          dangerouslySetInnerHTML={{ __html: passwordRequirement }}
        />
        {(errors.password || []).map((error, index) => (
          <p
            className="HelpText HelpText--noBottomMargin error"
            key={`password-${index}`}
          >
            {error}
          </p>
        ))}

        <label htmlFor="password_confirmation" className="c-gray-darker mt-16">
          {t('common.password_confirmation')}
        </label>
        <input
          type="password"
          id="password_confirmation"
          name="password_confirmation"
          onChange={this.handleInputChange}
          className="NewInput NewInput--white NewInput--fw mb-8"
          required
        />
        {this.notEmpty && !this.passwordMatch && (
          <p className="HelpText HelpText--noBottomMargin error">
            {t('users.reset_password.password_mismatch')}
          </p>
        )}
        {(errors.password_confirmation || []).map((error, index) => (
          <p
            className="HelpText HelpText--noBottomMargin error"
            key={`password_confirmation-${index}`}
          >
            {error}
          </p>
        ))}

        <div className="d-f jc-sb mt-16">
          <button
            type="submit"
            className={submitButtonClass}
            disabled={this.disableSubmitButton}
          >
            {t('common.password_submit')}
          </button>
        </div>
      </form>
    );
  }
}

export default PasswordForm;
